import React from 'react'
import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import { PAGE_META } from '../data/metaData'

export default function ForbiddenPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 bg-stone-950 text-white">
      <SeoHead
        title={PAGE_META.forbidden.title}
        description={PAGE_META.forbidden.description}
      />

      <div className="max-w-xl mx-auto text-center">
        <div className="w-16 h-16 rounded-2xl bg-red-500/20 text-red-400 flex items-center justify-center mx-auto mb-6 text-3xl font-black">
          403
        </div>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
          Adgang nægtet (Forbidden)
        </h1>

        <p className="mt-4 text-stone-300 text-base sm:text-lg leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side eller ressource. Benyt venligst navigationen nedenfor til at komme sikkert videre.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-[#015205] hover:bg-[#026b07] text-white font-bold text-sm shadow transition-colors"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true"></i>
            <span>Tilbage til forsiden</span>
          </Link>

          <Link
            to="/ydelser"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-stone-800 hover:bg-stone-700 text-white font-bold text-sm border border-stone-700 transition-colors"
          >
            <i className="fa-solid fa-list text-amber-400 text-xs" aria-hidden="true"></i>
            <span>Se vores ydelser</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
